import React from 'react'
import { formatCurrency } from '../../utils/api'
import ProgressBar from './ProgressBar'

function PricingResultsModal({
  results,
  onToggleSelection,
  onApply,
  onCancel,
  applying = false,
  progress = { current: 0, total: 0, status: '' }
}) {
  const selectedCount = results.filter(r => r.selected).length
  const changedCount = results.filter(r => r.changed).length
  const flaggedCount = results.filter(r => r.flagged).length
  const errorCount = results.filter(r => r.error).length

  const formatModalPrice = (price) => {
    if (price === null || price === undefined) return '—'
    if (price === 0) return '£0.00'
    if (price === 0.01) return '⚠ £0.01'
    return formatCurrency(price)
  }

  const selectAllProposed = () => {
    results.forEach(r => {
      if (!r.error && r.newPrice && r.newPrice > 0) {
        onToggleSelection(r.id, true)
      }
    })
  }

  const deselectAll = () => {
    results.forEach(r => {
      onToggleSelection(r.id, false)
    })
  }

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content modal-large" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Proposed Price Changes</h2>
          <button className="modal-close" onClick={onCancel}>&times;</button>
        </div>

        <div className="modal-info">
          Review the proposed prices below. Uncheck any items you don't want to update, then click "Apply Selected" to save.
        </div>

        <div className="modal-summary">
          <div className="summary-stat">
            <span className="summary-value">{results.length}</span>
            <span className="summary-label">Calculated</span>
          </div>
          <div className="summary-stat">
            <span className="summary-value text-success">{changedCount}</span>
            <span className="summary-label">Changed</span>
          </div>
          <div className="summary-stat">
            <span className="summary-value text-warning">{flaggedCount}</span>
            <span className="summary-label">Flagged</span>
          </div>
          <div className="summary-stat">
            <span className="summary-value text-info">{selectedCount}</span>
            <span className="summary-label">Selected</span>
          </div>
          {errorCount > 0 && (
            <div className="summary-stat">
              <span className="summary-value text-error">{errorCount}</span>
              <span className="summary-label">Errors</span>
            </div>
          )}
        </div>

        <div className="modal-selection-controls">
          <button className="btn btn-secondary btn-sm" onClick={selectAllProposed}>
            Select All Valid
          </button>
          <button className="btn btn-secondary btn-sm" onClick={deselectAll}>
            Deselect All
          </button>
        </div>

        <div className="modal-table-container">
          <table className="table">
            <thead>
              <tr>
                <th style={{ width: 40 }}>Apply</th>
                <th>Product</th>
                <th style={{ width: 100, textAlign: 'right' }}>Old Price</th>
                <th style={{ width: 100, textAlign: 'right' }}>New Price</th>
                <th style={{ width: 100, textAlign: 'center' }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {results.map((result) => (
                <tr
                  key={result.id}
                  className={result.selected ? 'row-selected' : result.error ? 'row-error' : ''}
                >
                  <td style={{ textAlign: 'center' }}>
                    <input
                      type="checkbox"
                      checked={result.selected}
                      onChange={() => onToggleSelection(result.id)}
                      disabled={result.error || !result.newPrice || result.newPrice <= 0}
                    />
                  </td>
                  <td className="text-truncate" style={{ maxWidth: 400 }}>{result.title}</td>
                  <td style={{ textAlign: 'right' }}>{formatModalPrice(result.oldPrice)}</td>
                  <td style={{ textAlign: 'right' }}>
                    {result.error ? (
                      <span className="text-error">Error</span>
                    ) : (
                      <span className={result.changed ? 'text-success' : ''}>
                        {formatModalPrice(result.newPrice)}
                      </span>
                    )}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {result.error && <span className="badge badge-error">Failed</span>}
                    {result.flagged && <span className="badge badge-warning">Review</span>}
                    {result.changed && !result.flagged && !result.error && (
                      <span className="badge badge-success">Changed</span>
                    )}
                    {!result.changed && !result.flagged && !result.error && (
                      <span className="badge badge-neutral">No Change</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="modal-footer">
          {applying ? (
            <ProgressBar
              current={progress.current}
              total={progress.total}
              status={progress.status}
            />
          ) : (
            <>
              <button className="btn btn-secondary" onClick={onCancel}>
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={onApply}
                disabled={selectedCount === 0}
              >
                Apply Selected ({selectedCount})
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default PricingResultsModal
